// External links and fixed strings the Flutter app hardcodes.

export const PRIVACY_POLICY_URL =
  'http://smartifyindia.co.in/policy/smartifyautomation/smartifyautomationprivacypolicy.html';

// linker.dart openWhatsApp() — where users fetch their OTP.
export const WHATSAPP_URL = 'https://wa.me/8624827530';

export const APP_TITLE = 'Smart Life India';

// Opens a link outside the webview. On Capacitor this hands off to the system
// browser / WhatsApp app; on web it is a normal new tab.
export function openExternal(url) {
  window.open(url, '_blank', 'noopener,noreferrer');
}
